export default {
  FORM_SUBMISSION_SUCCESSFUL: 'FORM_SUBMISSION_SUCCESSFUL',
  FORM_SUBMISSION_FAILED: 'FORM_SUBMISSION_FAILED',
};
